import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BcMatTemplateModule, PageLayoutModule } from '@beecore/mat-template';
import { BcFormModule } from '@beecore/form';
import { BcDialogsModule } from '@beecore/dialogs';
import { BcButtonsModule } from '@beecore/buttons';
import { BcCoreModule } from '@beecore/core';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  exports: [
    BcMatTemplateModule,
    BcFormModule,
    BcDialogsModule,
    BcButtonsModule,
    BcCoreModule,
    PageLayoutModule
  ]
})
export class BeecoreModule { }
